import React from 'react';
import { Link } from 'react-router-dom';
// Components
import Logo from '../Logo';
import Search from '../Search';
// Styles
import { Wrapper, Content } from './Header.styles';

const Header = () => (
  <Wrapper>
    <Content>
      <Link to='/' aria-label='A to Z Movie Database — home'>
        <Logo />
      </Link>
      <Search />
    </Content>
  </Wrapper>
);

export default Header;
